export default class AdminSitesViewpointsModalController {
  /* @ngInject*/
  constructor($uibModalInstance, $q, $scope, currentViewpoint, ViewpointManager, Modal, appConfig, Errors) {
    // Assign injected values to scope
    this.appConfig = appConfig;
    this.Errors = Errors;
    this.Modal = Modal;
    this.ViewpointManager = ViewpointManager;
    this.$uibModalInstance = $uibModalInstance;
    this.$q = $q;
    this.viewpointTypes = appConfig.viewpoints.INDEXES;
    this.selectedViewpoint = false;
    this.modalPayload = {};
    this.$scope = $scope;
    this.viewpoint = {
      name: '',
      desc: '',
    };

    this.filePreview = {
      before: null,
      after: null,
    };
    this.thumbnailStatus = {
      backfore: false,
      after: false
    };

    if(currentViewpoint) {
      this.selectedViewpoint = appConfig.viewpoints.INDEXES[currentViewpoint.type];
      this.modalPayload = currentViewpoint;
      this.viewpoint = currentViewpoint;
    }
  }

  setThumbnailStatus = (asset, boolean) => {
    this.thumbnailStatus[asset] = boolean;
  }

  resetViewpoint() {
    this.viewpoint = {
      name: '',
      desc: '',
    };
  }

  selectViewpointType(type) {
    this.modalPayload = this.getViewpointPayload(type);
    this.selectedViewpoint = type;
  }

  cancelUpload(event, image) {
    event.preventDefault();
    this.viewpoint.assets[image] = null;
    this.filePreview[image] = null;
  }

  dismissModal() {
    this.$uibModalInstance.dismiss();
  }

  sendViewpointToParent = form => {
    var $ctrl = this;
    if(form.$valid) {
      if(this.modalPayload.type === this.appConfig.viewpoints.TRUEVIEW) {
        $ctrl.uploadInProgress = true;
        $ctrl.ViewpointManager.create(this.modalPayload).then(viewpoint => {
          $ctrl.$uibModalInstance.close(viewpoint);
        }, err => {
          $ctrl.uploadInProgress = false;
          this.Errors.error({
            message: this.appConfig.errors.viewpoint.GENERAL_ERROR,
            error: err
          });
        });
      } else {
        $ctrl.$uibModalInstance.close(this.modalPayload);
      }
    } else {
      this.Errors.error({
        message: this.appConfig.errors.site.FORM_INCOMPLETE,
        error: form.$errors
      });
    }
  }

  onFileChange($files, key) {
    let $ctrl = this;
    let fileinput = $files[0];

    var reader = new FileReader();
    reader.onload = function(loadEvent) {
      $ctrl.$scope.$apply(function() {
        $ctrl.filePreview[key] = loadEvent.target.result;
      });
    };
    reader.readAsDataURL(fileinput);
  }

  getThumbnail(image) {
    // Used for fetching already saved images;
    if(!image) {
      return null;
    }
    if(image && image.hasOwnProperty('filename') && _.isString(image.filename)) {
      return this.appConfig.paths.IMAGES + image._id + '/' + image.filename;
    }
  }

  getViewpointPayload = type => {
    let $ctrl = this;
    let payload = null;
    $ctrl.resetViewpoint();
    switch (type) {
    case 0:
    case 'trueview':
      $ctrl.viewpoint.type = $ctrl.appConfig.viewpoints.TRUEVIEW;
      $ctrl.viewpoint.assets = {
        before: null,
        after: null
      };
      payload = $ctrl.viewpoint;
      break;
    case 1:
    case 'video':

      $ctrl.viewpoint.type = $ctrl.appConfig.viewpoints.VIDEO;
      $ctrl.viewpoint.video = {
        id: null,
        thumb: null
      };
      payload = $ctrl.viewpoint;
      break;
    default:
      this.Errors.error({
        message: this.appConfig.errors.viewpoint.VIEWPOINT_TYPE_ERROR,
        error: this.appConfig.errors.viewpoint.VIEWPOINT_TYPE_ERROR
      });
    }
    return payload;
  }
}



// WEBPACK FOOTER //
// ./client/components/modal/viewpoint/modal.component.js